"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClient = getClient;
exports.initializeGrpcTransport = initializeGrpcTransport;
var _connect = require("@connectrpc/connect");
var _connectWeb = require("@connectrpc/connect-web");
var _query_pb = require("@kentik/schema/gen/ts/kentik/query/v20251204alpha1/query_pb");
var _health_pb = require("@kentik/schema/gen/ts/grpc/health/v1/health_pb");
let _grpcTransport;
let _clients = null;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function initializeGrpcTransport($auth, type = 'json') {
  if (type === 'grpc-web') {
    _grpcTransport = (0, _connectWeb.createGrpcWebTransport)({
      baseUrl: '/',
      useBinaryFormat: false,
      interceptors: [next => req => {
        req.header.set('X-CSRF-Token', $auth.csrfToken);
        return next(req);
      }]
    });
  } else {
    _grpcTransport = (0, _connectWeb.createConnectTransport)({
      baseUrl: '/',
      interceptors: [next => req => {
        req.header.set('X-CSRF-Token', $auth.csrfToken);
        return next(req);
      }]
    });
  }
  _clients = {
    Health: (0, _connect.createClient)(_health_pb.Health, _grpcTransport),
    QueryService: (0, _connect.createClient)(_query_pb.QueryService, _grpcTransport)
  };
}
function getClient(name) {
  if (!_grpcTransport) {
    throw new Error('GRPC transport not initialized, call initializeGrpcTransport() first');
  }
  if (!_clients || !_clients[name]) {
    throw new Error(`Unable to find GRPC service client: ${name}`);
  }
  return _clients[name];
}